import React, { Component } from 'react';
import { BrowserRouter, Route, Switch } from "react-router-dom";
import Home from "./components/home";
import Explore from "./components/explore";
import AngelFallsAbseil from "./components/angel_falls_abseil";
import AkopanTrek from "./components/akopan_trek";
import KukenanTrek from "./components/kukenan_trek";
import FluvialKavacCanaima from "./components/fluvial_kavac_canaima";
import Andes from "./components/andes";
import RoraimaProwTrek from "./components/roraima_prow_trek";
import Climb from "./components/climb";
import Cycle from "./components/cycle";
import AndeanWay from "./components/andean_way";
import KamaYunek from "./components/kama_yunek";
import AndesGravel from "./components/andes_gravel";
import OurTeam from "./components/our_team";
import LostWorld from "./components/lost_world";
import RequestInfo from "./components/request_info";
import Error from "./components/error";
import NavBar from "./components/navbar";
import Footer from "./components/footer";

//import logo from './logo.svg';
//import './App.css';

class App extends Component {
  render() {
    return (
      //<div className="App">
      <BrowserRouter>
      <div className="">
          <NavBar />
          <Switch>
              <Route path="/" component={Home} exact/>
              <Route path="/explore" component={Explore} />
              <Route path="/angel_falls_abseil" component={AngelFallsAbseil} />
              <Route path="/akopan_trek" component={AkopanTrek} />
              <Route path="/kukenan_trek" component={KukenanTrek} />
              <Route path="/fluvial_kavac_canaima" component={FluvialKavacCanaima} />
              <Route path="/andes" component={Andes} />
              <Route path="/roraima_prow_trek" component={RoraimaProwTrek} />
              <Route path="/climb" component={Climb} />
              <Route path="/lost_world" component={LostWorld} />
              <Route path="/cycle" component={Cycle} />
              <Route path="/andean_way" component={AndeanWay} />
              <Route path="/kama_yunek" component={KamaYunek} />
              <Route path="/andes_gravel" component={AndesGravel} />
              <Route path="/our_team" component={OurTeam} />
              <Route path="/request_info" component={RequestInfo} />
              <Route component={Error} />
          </Switch>
          <Footer />
        </div>
      </BrowserRouter>
      //</div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js